export const DEFAULT_LOCALE = "en-US";

export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "pages.homepage";

// IAM Role ARNs for API Gateway authentication
export const SherlockApiRoleMap = {
  "beta": {
    "us-east-1": "arn:aws:iam::489729265110:role/SherlockWebapp-ExternalReadAndWriteRole-beta-NAAmazon",
    "us-west-2": "arn:aws:iam::485614217212:role/SherlockWebapp-ExternalReadAndWriteRole-beta-FEAmazon",
    "eu-south-2": "arn:aws:iam::510912409955:role/SherlockWebapp-ExternalReadAndWriteRole-beta-eu-south-2",
  },
  "prod": {
    "us-east-1": "arn:aws:iam::484548034642:role/SherlockWebapp-ExternalReadAndWriteRole-prod-NAAmazon",
    "us-west-2": "arn:aws:iam::454685686638:role/SherlockWebapp-ExternalReadAndWriteRole-prod-FEAmazon", 
    "eu-south-2": "arn:aws:iam::953391828056:role/SherlockWebapp-ExternalReadAndWriteRole-prod-eu-south-2",
  }
};
